import { tv } from 'tailwind-variants';

const ContainerTV = tv({
  base: '',
  variants: {
    type: {
      default: 'xs:w-full xl:w-[1188px] xl:m-auto xs:px-4 md:px-[89px] py-8 xl:px-0 xl:py-6',
      updated: 'xs:w-full xl:w-[1188px] xl:m-auto xs:px-4 lg:px-[89px] py-0 xl:px-0 xl:py-0',
      hd: 'px-4 xs:w-full lg:px-[89px] xl:max-w-[1350px] xl:m-auto xl:px-12 py-8',
      noPadding: 'p-0 w-full'
    },
    gap: {
      xs: 'gap-xs',
      sm: 'gap-sm',
      md: 'gap-md',
      lg: 'gap-lg',
      xl: 'gap-xl',
      xxl: 'gap-xxl'
    },
    direction: {
      col: 'flex flex-col',
      row: 'flex flex-row'
    }
  }
});

export { ContainerTV };
